import { render, staticRenderFns } from "./change-switch-text.mpx?vue&type=template&id=27933bd9&isComponent&outputPath=components%2Fchange-switch-text52ae8796%2Findex"
import script from "./change-switch-text.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fchange-switch-text52ae8796%2Findex"
export * from "./change-switch-text.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fchange-switch-text52ae8796%2Findex"
import style0 from "./change-switch-text.mpx?vue&type=style&index=0&id=27933bd9&prod&lang=stylus&mpxStyleOptions=%7B%22scoped%22%3Atrue%2C%22mid%22%3A%22_52ae8796%22%7D&isComponent&outputPath=components%2Fchange-switch-text52ae8796%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports